module.exports = __webpack_public_path__ + "static/media/download-blue.c8c887ae.svg";